"use client";

import { useTranslations } from "next-intl";
import { Link } from "@/i18n/navigation";
import { useModalZIndex } from "@/lib/use-modal-z-index";

interface SubscriptionConfirmModalProps {
  name: string;
  type: "artist" | "venue" | "show";
  onClose: () => void;
}

export function SubscriptionConfirmModal({
  name,
  type,
  onClose,
}: SubscriptionConfirmModalProps) {
  const t = useTranslations("Subscription");
  const zIndex = useModalZIndex();

  const heading = t("youreFollowing", { name: name.toUpperCase() });

  const description =
    type === "show"
      ? t("notifyShow")
      : type === "artist"
        ? t("notifyArtist", { name })
        : t("notifyVenue", { name });

  return (
    <div
      className="fixed inset-0 flex items-center justify-center bg-black/80 px-4 backdrop-blur-sm"
      style={{ zIndex }}
      onClick={onClose}
    >
      <div
        className="relative w-full max-w-sm border border-neutral-800 bg-surface px-8 py-8"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Corner markers */}
        <div className="absolute -top-1 -left-1 h-3 w-3 border-t border-l border-acid" />
        <div className="absolute -top-1 -right-1 h-3 w-3 border-t border-r border-acid" />
        <div className="absolute -bottom-1 -left-1 h-3 w-3 border-b border-l border-acid" />
        <div className="absolute -bottom-1 -right-1 h-3 w-3 border-b border-r border-acid" />

        <h2 className="mb-2 text-center font-mono text-sm font-bold tracking-wider text-white">
          {heading}
        </h2>
        <p className="mb-6 text-center text-sm text-neutral-400">
          {description}
        </p>

        <button
          onClick={onClose}
          className="mb-3 block w-full rounded bg-acid py-2.5 text-center font-mono text-sm font-bold text-black transition-opacity hover:opacity-90 cursor-pointer"
        >
          {t("gotIt")}
        </button>

        <p className="text-center font-mono text-xs text-neutral-500">
          <Link
            href="/profile"
            rel="nofollow"
            className="text-acid transition-colors hover:text-white"
            onClick={onClose}
          >
            {t("viewProfile")}
          </Link>
        </p>
      </div>
    </div>
  );
}
